function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};
class MobileNav extends HTMLElement {
  constructor() {
    super();
    this.opener = this.querySelector(".global--header--mobile-menu__wrapper");
    this.icon = this.querySelector(".global--header--mobile-menu__icon");
    this.nav = this.querySelector(".global--header--mobile-menu__content");
    this.bindEvents();
  }
  bindEvents() {
    this.opener.addEventListener("click", this.toggleMenu.bind(this));
  }
  toggleMenu() {
    if (
      this.opener.classList.contains(
        "global--header--mobile-menu__wrapper--active"
      )
    ) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }
  openMenu() {
    function preventDefault(e) {
      e.preventDefault();
    }
    this.nav.classList.add("global--header--mobile-menu__content--active");
    this.icon.classList.add("global--header--mobile-menu__icon--active");
    this.opener.classList.add("global--header--mobile-menu__wrapper--active");
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
  }
  closeMenu() {
    function preventDefault(e) {
      e.preventDefault();
    }
    this.nav.classList.remove("global--header--mobile-menu__content--active");
    this.icon.classList.remove("global--header--mobile-menu__icon--active");
    this.opener.classList.remove(
      "global--header--mobile-menu__wrapper--active"
    );
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("position");
    document.body.style.removeProperty("width");
  }
}
customElements.define("mobile-nav", MobileNav);
class FooterMobileMenu extends HTMLElement {
  constructor() {
    super();
    this.footerAccordions = document.querySelectorAll(
      ".component--footer--menu-accordions__tab"
    );
    this.bindEvents();
  }
  bindEvents() {
    this.footerAccordions.forEach((accordion) =>
      accordion.addEventListener("click", this.toggleFooterAccordion.bind(this))
    );
  }
  toggleFooterAccordion(event) {
    const element = event.currentTarget;
    const itemToggle = element.getAttribute("aria-expanded");
    for (let i = 0; i < this.footerAccordions.length; i++) {
      this.footerAccordions[i].setAttribute("aria-expanded", "false");
    }
    if (itemToggle == "false") {
      element.setAttribute("aria-expanded", "true");
    }
  }
}
customElements.define("footer-mobile-menu", FooterMobileMenu);
class FooterNewsletter extends HTMLElement {
  constructor() {
    super();
    this.defaults = {
      newsletter: "[data-footer-newsletter-form]",
      newsletterInput: ".component--footer--newsletter__input",
      newsletterInputField: ".component--footer--newsletter__field",
      newsletterMessages: ".component--footer--newsletter__messages",
      successMessage: ".component--footer--newsletter__success-message",
      errorMessage: ".component--footer--newsletter__error-message",
    };
    this.newsletter = document.querySelector(this.defaults.newsletter);
    this.newsletterInput = document.querySelector(
      this.defaults.newsletterInput
    );
    this.newsletterInputField = document.querySelector(
      this.defaults.newsletterInputField
    );
    this.newsletterMessages = document.querySelector(
      this.defaults.newsletterMessages
    );
    this.newsletterSuccessMessage = document.querySelector(
      this.defaults.successMessage
    );
    this.newsletterErrorMessage = document.querySelector(
      this.defaults.errorMessage
    );
    this.bindEvents();
  }
  bindEvents() {
    this.newsletter.addEventListener("submit", this.submitForm.bind(this));
  }
  successMessages() {
    this.newsletterSuccessMessage.style.display = "block";
    this.newsletterErrorMessage.style.display = "none";
    this.newsletterInputField.style.display = "none";
  }
  errorMessages(ele, error) {
    const html = `<svg width="12" height="12" viewBox="0 0 12 12" fill="#e2665c" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 0C2.6934 0 0 2.6934 0 6C0 9.3066 2.6934 12 6 12C9.3066 12 12 9.3066 12 6C12 2.6934 9.3066 0 6 0ZM6 1.2C8.65807 1.2 10.8 3.34193 10.8 6C10.8 8.65807 8.65807 10.8 6 10.8C3.34193 10.8 1.2 8.65807 1.2 6C1.2 3.34193 3.34193 1.2 6 1.2ZM5.4 3V4.2H6.6V3H5.4ZM5.4 5.4V9H6.6V5.4H5.4Z" />
            </svg>${error}`;
    ele.innerHTML = html;
    ele.style.display = "block";
    this.newsletterInput.style.border = "2px solid #e2665c";
  }
  resetForm() {
    this.newsletterSuccessMessage.style.display = "none";
    this.newsletterErrorMessage.style.display = "none";
    this.newsletterErrorMessage.innerHTML = "";
    this.newsletterInputField.style.display = "block";
  }
  validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  subscribe(id, email) {
    const data = {
      g: id,
      email: email,
    };
    const urlData = new URLSearchParams(data);
    const url = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
    fetch(url, {
      method: "POST",
      async: true,
      crossDomain: true,
      body: urlData,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Cache-Control": "no-cache",
      },
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.success) {
          if (res.data.is_subscribed) {
            this.errorMessages(
              this.newsletterErrorMessage,
              "This email address has already subscribed."
            );
          } else {
            this.successMessages();
          }
        } else {
          this.errorMessages(
            this.newsletterErrorMessage,
            "Invalid Email Address."
          );
        }
      })
      .catch((err) => {
        this.errorMessages(
          this.newsletterErrorMessage,
          "Something went wrong!"
        );
      });
  }
  submitForm(e) {
    e.preventDefault();
    const email = this.newsletter.elements["email"].value;
    const listId = this.newsletter.elements["g"].value;
    if (email !== "") {
      if (this.validateEmail(email)) {
        this.subscribe(listId, email);
      } else {
        this.errorMessages(
          this.newsletterErrorMessage,
          "Invalid Email Address."
        );
      }
    } else {
      this.errorMessages(
        this.newsletterErrorMessage,
        "Email Address Required."
      );
    }
    return false;
  }
}
customElements.define("footer-newsletter", FooterNewsletter);
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.defaults = {
      cartDrawerClose: "[data-cart-drawer-close]",
      cartDrawerTrigger: "[data-cart-drawer-trigger]",
      cartOverlay: "[data-cart-drawer-overlay]",
    };
    this.bindEvents();
    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 100);
    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }
  bindEvents() {
    document
      .querySelector(this.defaults.cartDrawerTrigger)
      .addEventListener("click", this.openCart.bind(this));
    document
      .querySelectorAll(this.defaults.cartDrawerClose)
      .forEach((item) =>
        item.addEventListener("click", this.closeCart.bind(this))
      );
    document
      .querySelector(this.defaults.cartOverlay)
      .addEventListener("click", this.closeCart.bind(this));
  }
  updateCartCount() {
    fetch(`/cart.js`)
      .then((response) => {
        return response.json();
      })
      .then((state) => {
        document.querySelector("[data-cart-count]").innerHTML =
          state.item_count;
        window.change_text_gamification(state)
        window.sidecartGammification()

      })
      .catch((e) => {
        console.error(e);
      });
  }
  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
    this.updateCartCount();
  }
  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section).innerHTML = this.getSectionInnerHTML(
        parsedState,
        section
      );
    });
    this.bindEvents();
    this.openCart();
    this.remountUpsell();
    this.updateCartCount();
  }
  remountUpsell() {
    if (
      document.querySelectorAll(".component--cart-drawer--upsell-slider--card")
        .length == 0
    ) {
    } else {
      document.querySelector(
        ".component--cart-drawer--upsell-slider"
      ).style.display = "block";
      new Splide(".component--cart-drawer--upsell-slider__splide", {
        type: "loop",
        perPage: 1,
        pagination: false,
        arrows: true,
        width: "100%",
      }).mount();
    }
  }
  getSectionsToRender() {
    return [`component--cart-drawer--items`, `component--cart-drawer--footer`];
  }
  getSectionInnerHTML(html, selector) {
    const h = new DOMParser().parseFromString(html, "text/html");
    return h.getElementById(selector).innerHTML;
  }
  updateQuantity(line, quantity, name) {
    const body = JSON.stringify({
      line,
      quantity,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then(() => {
        fetch(`/?section_id=global--cart-drawer`)
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            this.getSectionsToRender().forEach((section) => {
              document.getElementById(section).innerHTML =
                this.getSectionInnerHTML(state, section);
            });
            this.remountUpsell();
            this.bindEvents();
            this.updateCartCount();
          });
      })
      .catch((e) => {
        console.log(e);
      });
  }
  openCart() {
    document.body.style.overflow = "hidden";
    document.querySelector(".global--cart-drawer__drawer").style.display =
      "block";
    document
      .querySelector(".global--cart-drawer__drawer")
      .classList.add("global--cart-drawer__drawer--active");
    document
      .querySelector(".global--cart-drawer__overlay")
      .classList.add("global--cart-drawer__overlay--active");
  }
  closeCart() {
    document.body.style.overflow = "visible";
    document
      .querySelector(".global--cart-drawer__drawer")
      .classList.remove("global--cart-drawer__drawer--active");
    document
      .querySelector(".global--cart-drawer__overlay")
      .classList.remove("global--cart-drawer__overlay--active");
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-drawer").updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("cart-drawer-remove-button", CartDrawerRemoveButton);
class CartDrawerQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define("cart-drawer-quantity-input", CartDrawerQuantityInput);
class CartDrawerProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cart = document.querySelector("cart-drawer");
  }
  onSubmitHandler(evt) {
    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute("disabled", true);
    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
    });
    fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
      .then((response) => response.text())
      .then(() => {
        fetch(`/?section_id=global--cart-drawer`)
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            this.cart.renderContents(state);
          });
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.removeAttribute("disabled");
      });
  }
}
customElements.define("cart-drawer-product-form", CartDrawerProductForm);
class CollectionProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cart = document.querySelector("cart-drawer");
  }
  onSubmitHandler(evt) {
    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute("disabled", true);
    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
    });
    fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
      .then((response) => response.text())
      .then(() => {
        fetch(`/?section_id=global--cart-drawer`)
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            this.cart.renderContents(state);
          });
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.removeAttribute("disabled");
      });
  }
}
customElements.define("collection-product-form", CollectionProductForm);
class GlobalFAQ extends HTMLElement {
  constructor() {
    super();
    this.accordions = document.querySelectorAll(
      ".component--home--faq--question"
    );
    this.bindEvents();
  }
  bindEvents() {
    this.accordions.forEach((accordion) =>
      accordion.addEventListener("click", this.toggleAccordion.bind(this))
    );
  }
  toggleAccordion(event) {
    const element = event.currentTarget;
    element.classList.toggle("component--home--faq--question--active");
  }
}
customElements.define("global-faq", GlobalFAQ);
